import { Question } from "../../interfaces/purchase-order.interface";
import { QuestionType } from "../../enums/question-type.enum";

export class VerificationQuestions {
  public static question_invoice_main: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio-question-select",
      question_confirm: "¿Se pudo consultar la información del comprobante con el código QR?",
      answer_confirm: undefined,
      open_select: "yes",
      control: "qr_scanned",
      options: [
        { label: "Sí", value: { value: "yes", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "El documento debe ser legible: en tamaño carta y con buena nitidez, no se detectó información ni se pudo leer el código QR.",
          },
        },
      ],
      answer: undefined,
      label: "¿Qué medio usaste?",
      select_options: [
        { label: "Código QR", value: { value: "Código QR", incident: false } },
        { label: "Consulta Manual", value: { value: "Consulta Manual", incident: false } },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿Se trata de la última verificación vigente?",
      control: "current_verification",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Gestiona el pago de multa por verificacion extemporánea y derechos, y carga las evidencias.",
          },
        },
      ],
      page: 1,
    },
  ];

  public static question_invoice_checkbox: Question[] = [
    {
      type: "checkbox",
      question: "Marca los datos que aparecen en la verificación.",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "niv",
      label: "",
      answer: undefined,

      page: 1,
    },
    {
      type: "checkbox",
      question: "",
      additional_information: "Clave vehicular",
      control: "key_vehicle",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      question: "",
      additional_information: "Número de motor",
      control: "engine_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      question: "",
      additional_information: "Año",
      control: "model",
      label: "",
      answer: undefined,
      page: 1,
    },
  ];
}
